export const AddressBookModalHeader = [
    {
        sortable:true,
        class: 'cursor-pointer',
        display:'Name',
        id:'name'
    },
    {
        sortable:false,
        class: '',
        display:'Address 1',
        id:'address1'
    },
    {
        sortable:false,
        class: '',
        display:'Address 2',
        id:'id'
    },
    {
        sortable:true,
        class: 'cursor-pointer',
        display:'Postcode',
        id:'postcode'
    },
    {
        sortable:false,
        class: '',
        display:'City',
        id:'city'
    },
    {
        sortable:false,
        class: '',
        display:'State',
        id:'State'
    },
    {
        sortable:false,
        class: '',
        display:'Country',
        id:'country'
    },
    {
        sortable:false,
        class: '',
        display:'Contact',
        id:'contact'
    },
    {
        sortable:false,
        class: '',
        display:'Private',
        id:'private'
    },
]